import { userRoles, userTypes } from 'utils/constants';

// `orgs` is every org doc the user belongs to (`org_ids`), residents' orgs included. While the root
// role is `operator` the web reads the operator view from `userData.orgs[active_org_id]`, so an org
// without an operator record (e.g. one where the person was removed from the team and is only a
// resident now) must not be offered: activating it leaves the user with no permissions there and
// every route answers 404. Falls back to the full list when `userData.orgs` carries no entries at all
// (legacy accounts), so the selector is never emptied by missing data.
export const getSwitchableOrgs = (orgs, userData) => {
    if (
        !orgs ||
        userData?.role !== userRoles.OPERATOR ||
        userData?.type === userTypes.SUPER_ADMIN ||
        userData?.external
    ) {
        return orgs;
    }

    const teamOrgIds = Object.keys(userData.orgs ?? {});

    if (!teamOrgIds.length) {
        return orgs;
    }

    return orgs.filter(org => teamOrgIds.includes(org.org_id));
};
